import { gql } from '@apollo/client'

export const CLONE_EQUIPMENTS = gql`
  mutation cloneEquipments($payload: JSON!) {
    cloneEquipments(payload: $payload) {
      success
    }
  }
`
